
import router from '../router/router.js';


/**
 *  Error object for API failures...
 *  API failures are unfortunately pretty common. And we want to handle
 *  them consistently throughout the app. However, it's also very nice
 *  To have the ability to return control back to the caller, rather than
 *  solely relying on an axios interceptor to do all of the heavy lifting
 *  (Plus we can't call composables in the handler!). 
 *  
 *  So here is an error class to do just that. This error type handles 
 *  Errors coming from the ServerAPI and consistently handles the messages
 *  Have a look at /http/http.js to see how the ApiError object is called
 *  by the interceptor error callback. 
 *
 *  Basically, what we do is reformat any data as needed, and/or set a
 *  toastPayload that drops directly into our toast.add() function. If you
 *  need custom functionality? Simply don't use toast.add() and handle it
 *  yourself.
 */

export class ApiError extends Error {
  constructor ({ config, data, errors, message, request, response, status }) {
    super();
    this.name = 'wholebodyappApiError';
    this.config = config;
    this.data = response?.data;
    this.message = message;
    this.request = request;
    this.response = response;
    this.status = status;

    // TODO: handle canceled request?

    // if ! request, we know the server never even bothered to respond.
    if (!response) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Service isn\'t responding',
        detail: 'The service you requested is unable to respond at this time. Please try again later.'
      };
      return;
    }
    // if (response?.status === 400)  tie into validation library!
    if (response?.status === 401) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Not logged in',
        detail: 'You do not have a valid session. Please log in to resume.',
      };
      router.push({path: '/', query: {redir: router?.currentRoute?.value?.fullPath }});
      return;
    }
    if (response?.status === 403) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Service unavailable',
        detail: 'The service you requeset is temporary unavailable, or encountered an unknown errror. If this persists, please contact tech support.',
      };
      return;
    }
    if (response?.status === 409) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Data conflict',
        detail: 'The request would cause a data conflict, so it has been not been accepted. Check the request and retry.',
      };
      return;
    }
    if (response?.status === 429) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Take a break',
        detail: 'You have made too many requests. Take a break and try again later.',
      };
      return;
    }
    if (response?.status >= 500) {
      this.toastMessage = {
        variant: 'danger-soft',
        hed: 'Service unavailable',
        detail: 'The service you requested is temporary unavailable, or encountered an unknown errror. If this persists, please contact tech support.',
      };
      return;
    }
    // this.toastMessage = {
    //   variant: 'danger-soft',
    //   hed: 'Unknown error',
    //   detail: 'The service encourtered an unexpected error. Plase contact tech support',
    // };
  }
}
